import styled, { css } from "styled-components";
import { animatedSkeletonStyle, BiColor } from "@ui/styles/animatedSkeleton";
import { mobile } from "@ui/styles/utils";

export const TextSkeleton = styled.div.withConfig({
	shouldForwardProp: (prop) => !["grow", "height", "biColor"].includes(prop),
})<{ grow?: boolean; height?: number; biColor?: BiColor }>`
	${animatedSkeletonStyle};
	height: ${({ height }) => height ?? 8}px;
	border-radius: 13px;
	max-width: 130px;
	${({ grow }) => grow && "flex:1;"}
`;
export const LargeTextSkeleton = styled.div.withConfig({
	shouldForwardProp: (prop) => !["height", "width", "biColor"].includes(prop),
})<{ height?: number; width?: number; biColor?: BiColor }>`
	${animatedSkeletonStyle};
	height: ${({ height }) => height ?? 8}px;
	width: ${({ width }) => width ?? 135}px;
	border-radius: 13px;
	max-width: 135px;
	@media ${mobile} {
		max-width: 40px;
	}
`;

export const CircleSkeleton = styled.div.withConfig({
	shouldForwardProp: (prop) => !["size", "biColor"].includes(prop),
})<{ size: number; biColor?: BiColor }>`
	${animatedSkeletonStyle};

	${({ size }) => css`
		width: ${size}px;
		height: ${size}px;
		border-radius: ${size / 2}px;
	`}
`;
